export const LABEL_VERIFIED_DEGREES = 'verified_degrees'
